import { Capacitor } from '@capacitor/core';

/**
 * Get safe area padding styles
 * @param {Object} insets - Safe area insets
 * @param {string} edges - Edges to apply ('top', 'bottom', 'left', 'right', 'all', 'vertical', 'horizontal')
 * @returns {Object} CSS styles
 */
export const getSafeAreaPadding = (insets, edges = 'all') => {
  if (!Capacitor.isNativePlatform()) return {};

  const { top = 0, bottom = 0, left = 0, right = 0 } = insets;

  switch (edges) {
    case 'top': return { paddingTop: `${top}px` };
    case 'bottom': return { paddingBottom: `${bottom}px` };
    case 'left': return { paddingLeft: `${left}px` };
    case 'right': return { paddingRight: `${right}px` };
    case 'horizontal': return { paddingLeft: `${left}px`, paddingRight: `${right}px` };
    case 'vertical': return { paddingTop: `${top}px`, paddingBottom: `${bottom}px` };
    case 'all':
    default: return {
      paddingTop: `${top}px`,
      paddingBottom: `${bottom}px`,
      paddingLeft: `${left}px`,
      paddingRight: `${right}px`
    };
  }
};

/**
 * Check if device has safe area (notch, home indicator, etc.)
 * @param {Object} insets - Safe area insets
 * @returns {boolean}
 */
export const hasSafeArea = (insets) => {
  if (!Capacitor.isNativePlatform()) return false;
  const { top = 0, bottom = 0, left = 0, right = 0 } = insets;
  return top > 0 || bottom > 0 || left > 0 || right > 0;
}; 